<template>
  <v-dialog
    v-model="dialog"
    width="448"
    open-on-focus
    no-click-animation
    persistent
    content-class="exercise-share-dialog"
    @click:outside="onClickOutside"
    @keydown="onKeydown"
  >
    <v-card elevation="0">
      <v-form ref="form" class="exercise-share-form" @submit.prevent="onSubmit">
        <div class="exercise-share-form-body">
          <v-toolbar
            flat
            height="76"
          >
            <v-toolbar-title class="exercise-share-toolbar-title">Share from company</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn
              color="accent"
              icon
              tile
              @click="closeDialog"
            >
              <v-icon size="24">mdi-close</v-icon>
            </v-btn>
          </v-toolbar>
          <v-container class="new-practice-card-container">
            <div class="exercise-share-patients">
              <v-tabs-items
                class=""
                v-model="tab"
              >
                <v-tab-item>
                  <main-user-table
                    :headers="headers"
                    :items="computedPractices"
                    :items-per-page="queryParams.pageSize"
                    :server-items-length="dialogPagination.totalCount || -1"
                    :page="queryParams.page"
                    :row-component="'choose-practice-table-row'"
                    @to-user="selectPractice"
                    @action:get-data="getPracticesAction"
                  />
                </v-tab-item>
                <v-tab-item>
                  <main-user-table
                    :headers="headers"
                    :items="searchedExerciseDefinitions"
                    :items-per-page="queryParams.pageSize"
                    :server-items-length="dialogPagination.totalCount || -1"
                    :page="queryParams.page"
                    :row-component="'exercise-definition-selectable-table-row'"
                    @choose-exercise="chooseExerciseDefinition"
                  />
                </v-tab-item>
              </v-tabs-items>
            </div>
          </v-container>
        </div>
        <div class="exercise-share-footer">
          <v-container class="pt-0 pb-4">
            <v-row>
              <v-col class="d-flex">
                <v-btn elevation="0" rounded @click="clearSelected" v-if="tab==1">Cancel</v-btn>
                <v-spacer/>
                <v-btn v-if="tab==0" :disabled="!formIsValidCheck" elevation="0" rounded color="accent" @click="getDefinitions">Select</v-btn>
                <v-btn v-else :disabled="!formIsValidCheck" elevation="0" rounded color="accent" @click="importDefinitions">Import</v-btn>
              </v-col>
            </v-row>
          </v-container>
        </div>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'

import MainUserTable from "@/components/tables/MainUserTable"
import RouterMixin from "@/mixins/router"
import { debounce } from '@/helpers/debounce'

export default {
  name: 'ExerciseImportCompaniesDialog',
  components: {
    MainUserTable
  },
  props: {
    showDialog: {
      type: Boolean,
      default: false
    },
  },
  mixins: [RouterMixin],
  data () {
    return {
      dialog: false,
      headers: [],
      selectedPractices: [],
      formIsValidCheck: false,
      singleChoose: true,
      searchedExerciseDefinitions: [],
      selectedExerciseDefinitionsData: [],
      tab: 0
    }
  },
  watch: {
    showDialog: function (val) {
      if (val) {
        this.dialog = true
        this.getData()
      }
    },
    dialogExerciseDefinitions: function(val) {
      if (val && this.dialog) {
        // this.selectedExerciseDefinitionsData = this.dialogExerciseDefinitions.map(item=>{
        //   return {...item, ...{selected: true}}
        // })
        this.calculateExerciseDefinitions()
      }
    }
  },
  computed: {
    ...mapState('exercisesStates', [
      'sharingCompanies',
      'sharingCompany',
      'dialogPagination',
      'dialogExerciseDefinitions'
    ]),
    computedPractices () {
      let practices = []
      this.sharingCompanies.forEach(item=>{
        let selected = false
        if (this.selectedPractices.includes(item.id)) selected = true
        practices.push({selected: selected, ...item})
      })
      return practices
    },
  },
  methods: {
    ...mapActions('exercisesStates', [
      'getSharedExerciseDefinitionsCompanies',
      'getSharedExerciseDefinitionsFromCompany',
      'shareExerciseDefinition'
    ]),
    getData(data = {}) {
      if (this.dialog) this.getSharedExerciseDefinitionsCompanies(data);
    },
    closeDialog () {
      this.dialog = false
      this.editedUser = { practiceId: this.practiceId }
      this.userToSave = {}
      this.selectedExerciseDefinitionsData = []
      this.selectedPractices = []
      this.tab = 0
      this.$emit('close-dialog')
    },
    onClickOutside() {
      this.closeDialog()
    },
    onKeydown(key) {
      if (key.code === "Escape" && key.isTrusted) this.closeDialog()
    },
    clearForm () {
      this.$refs.form.reset()
    },
    onSubmit () {
      this.$emit('on-submit', this.selectedPractices)
      this.editedUser = { practiceId: this.practiceId }
      this.userToSave = {}
      this.closeDialog()
    },
    searchRun(text) {
      debounce(()=>{
        this.getDataAction({ ...this.queryParams, name: text }, false)
        this.selectedPractices = []
        this.formIsValid()
      }, 500, 'getPractices')
    },
    selectPractice({id, value}) {
      debounce(()=>{
        if (!this.singleChoose) {
          let i = this.selectedPractices.indexOf(id)
          if (value==0) {
            if (i !== -1) {
              this.selectedPractices.splice(i, 1)
            }
          } else {
            if (i==-1)
            this.selectedPractices.push(id)
          }
        } else {
          if (value==0)
            this.selectedPractices = []
          else this.selectedPractices = [id]
        }
        this.formIsValid()
      },100, 'selectPractice')
    },
    chooseExerciseDefinition(id) {
      let ind = this.selectedExerciseDefinitionsData.findIndex(exercise=>exercise.id == id)
      if (ind>-1) {
          this.selectedExerciseDefinitionsData.splice(ind, 1)
      }
      else {
        let tmpExercise = this.dialogExerciseDefinitions.find(exercise=>exercise.id == id)
        if (tmpExercise) tmpExercise.selected = true
        this.selectedExerciseDefinitionsData.push(tmpExercise)
      }
      this.calculateExerciseDefinitions()
      console.log(this.selectedExerciseDefinitionsData)
    },
    calculateExerciseDefinitions() {
      this.searchedExerciseDefinitions = [...this.dialogExerciseDefinitions]
      console.log(this.selectedExerciseDefinitionsData)
      this.searchedExerciseDefinitions.forEach((item,index)=>{
        if (this.selectedExerciseDefinitionsData.findIndex(item2=>item2.id == item.id) > -1) {
          this.searchedExerciseDefinitions[index] = Object.assign(
          {},
          this.searchedExerciseDefinitions[index],
          { selected: true })
          console.log('assign selected', index)
        }
        else this.searchedExerciseDefinitions[index]['selected'] = false
      })
    },
    getDefinitions() {
      console.log(this.selectedPractices[0])
      this.getSharedExerciseDefinitionsFromCompany({companyId: this.selectedPractices[0]})
      this.tab = 1
    },
    async importDefinitions() {
      console.log(this.selectedExerciseDefinitionsData)
      if (this.selectedExerciseDefinitionsData?.length>0) this.selectedExerciseDefinitionsData.forEach(item=>{
        this.shareExerciseDefinition({exerciseId: item.id, type: item.type, company: true})
        this.$emit('reload-exercises')
      })
      this.closeDialog()
    },
    setDate({id, value}) {
      this.sequenceStartDate = value
      this.formIsValid()
    },
    formIsValid() {
      if (this.selectedPractices.length==0) this.formIsValidCheck = false
      else this.formIsValidCheck = true
    },
    sharePractices() {
      if (this.formIsValidCheck) this.$emit('share-practices', this.selectedPractices)
    },
    getPracticesAction(data) {
      debounce(()=>{
        this.getDataAction({... this.queryParams, ...data}, false)
      }, 500, 'getPractices')
    },
    selectAll() {
      this.selectedPractices = this.computedPractices.map(practice=>{
        return practice.id
      })
      this.formIsValid()
    },
    clearSelected() {
      this.tab = 0
      this.selectedExerciseDefinitionsData = []
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/styles/variables.scss";

.exercise-share {
  &-dialog {
    margin: $gutter;
    margin-left: auto;
    height: 100%;
    max-height: calc(100% - #{2*$gutter}) !important;
    // display: flex;
    // flex-direction: column;
    // background-color: red !important;
    // looks little hacky
    > .v-card {
      width: 100%;
      height: 100%;
      background-color: $bh-blue--4;
      overflow: auto;
      display: flex;
      flex-direction: column;
    }
  }
  &-toolbar-title {
    color: $bh-blue;
    font-weight: bold;
  }
  &-tabs {
    padding:0 24px;
    background:#ffffff;
    .v-tab {
      color:$bh-blue;
      text-transform: none;
      letter-spacing: 0;
      font-size: 1em;
      &:not(.v-tab--active) {
        color:white;
      }
    }
    .v-tabs-slider {
      background:$bh-blue;
    }
  }
  &-v-tabs-items {
    background:$bh-blue--4 !important;
  }

  &-card {
    &-title {
      font-size: $font-size-root;
      color: $bh-blue;
      padding-left: 1.5*$gutter;
      padding-right: 1.5*$gutter;
    }
    &-container {
      padding-left: 1.5*$gutter;
      padding-right: 1.5*$gutter;
    }
    &-footer {
      padding: 1.5*$gutter;
    }
  }
  &-form {
    height: 100%;
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    min-height: 0;
    &-body {
      display: flex;
      flex-direction: column;
      height: auto;
      flex-shrink: 1;
      ::v-deep .v-toolbar__content {
        padding-left: 1.5*$gutter;
        padding-right: 1.5*$gutter;
      }
    }
    &-col-left {
      padding-top: 0;
      padding-right: 0.25*$gutter;
    }
    &-col-right {
      padding-top: 0;
      padding-left: 0.25*$gutter
    }
  }
  &-user-patients {
    padding: 12px 24px;
  }
}
</style>
